<template>
  <div class="recognitionResult">
    <van-sticky>
      <div class="textHeader">
        <van-icon name="arrow-left" color="#777" class="vanIconText" @click="returnIndex" />
        <span>识别信息</span>
      </div>
    </van-sticky>
    <div class="content">
      <van-cell-group>
        <van-field label="卡号" v-model="formData.cardNo" type="number" />
        <van-field label="姓名" v-model="formData.customerName" />
        <div v-for="(item,index) in formData.orderList" :key="index" class="formList">

          <!-- <img id="showImg" :src="item.imageBase" height="200" /> -->
          <van-field disabled label="订单编号" v-model="item.orderNo" />
          <van-field disabled label="平台" value="大众点评" />
          <van-field disabled label="平台用户名" v-model="item.platName" />
          <div>
            <!-- <div v-if="item.bussinessChannel=='大众点评'"> -->
            <van-field disabled label="券号" v-model="item.verificatioCode" />
            <van-field disabled label="商品总价" v-model="item.allPrice" />
            <van-field disabled label="商家立减" v-model="item.businessReduce" />
            <van-field disabled label="平台立减" v-model="item.platformReduce" />
            <van-field disabled label="平台抵用券" v-model="item.voucher" />
            <van-field disabled label="优惠金额" v-model="item.discount" />
            <van-field disabled label="订单总价" v-model="item.orderPrice" />
            <van-field disabled label="实付款" v-model="item.actualPrice" />
            <van-field disabled label="预付款" v-model="item.advancePayment" />
            <van-field disabled label="尾款" v-model="item.balancePayment" />
          </div>
          <!-- <div v-if="item.bussinessChannel=='新氧'">
            <van-field disabled label="预约码" v-model="item.cppointmentCode" />
            <van-field disabled label="订单总金额" v-model="item.businessReduce" />
            <van-field disabled label="实付预约金" v-model="item.platformReduce" />
            <van-field disabled label="剩余应付(尾款)" v-model="item.voucher" />
            <van-field disabled label="本单实付金额" v-model="item.orderPrice" />
          </div> -->
          <div class="arrowLine">
            <van-field v-model="item.cardName" label="是否多次卡:" @click="handCard(index);showCard = true;" disabled />
            <van-icon name="arrow" color="#2765C7" />
            <van-action-sheet v-model="showCard" :actions="actionsCard" @select="onCard" />
          </div>
          <div class="arrowLine">
            <van-field v-model="item.areaName" label="平台院区:" @click="handArea(index);showArea = true;" disabled />
            <van-icon name="arrow" color="#2765C7" />
            <van-action-sheet v-model="showArea" :actions="actionsArea" @select="onArea" />
          </div>
          <div class="arrowLine">
            <van-field v-model="item.dsepartmentName" label="科室:" @click="handRoom(index);showRoom = true;" disabled />
            <van-icon name="arrow" color="#2765C7" />
            <van-action-sheet v-model="showRoom" :actions="actionsRoom" @select="onRoom" />
          </div>
          <div class="buttonContinue">
            <van-button class="continueButton" type="danger" size="mini" round color="#0364A8">继续识别
            </van-button>
            <input type="file" id="img" accept="image/*" @change="addProject($event,index)" class="imgInputOne" />
          </div>
          <div v-for="(img,index) in item.imageBase" :key="index">
            <img id="showImg" :src="img" height="200" />
          </div>
        </div>
      </van-cell-group>

    </div>
    <div class="textFoot">
      <van-button class="dangerButton" plain type="info" size="mini" round @click="addOrder">添加订单</van-button>
      <van-button class="dangerButton" type="danger" size="mini" round color="#0364A8" @click="confirmed">信息确认
      </van-button>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios"
import bus from '../../assets/js/bus';
import { importScanImage } from '@/axios/api'
export default {
  name: 'recognitionResult',
  props: ['formList',],
  data() {
    return {
      access_token: '24.ddd193fe368099c77e2233678ec2c6e7.2592000.1657419422.282335-25315974',
      showArea: false,
      showCard: false,
      showRoom: false,
      offFirstEnter: true,
      data: '',
      index: '',
      formData: {
        cardNo: '',
        orderList: []
      },
      actionsArea: [{
        name: "伯思立",
        id: 'bsl',
      }, {
        name: "百达丽",
        id: 'bdl',
      }, {
        name: "翡丽思",
        id: 'fls',
      },],
      actionsRoom: [{
        name: "诊外",
        id: 'zw',
      }, {
        name: "皮肤科",
        id: 'pfk',
      }, {
        name: "注射科",
        id: 'zsk',
      },],
      actionsCard: [{
        name: "是",
        id: 1,
      }, {
        name: "否",
        id: 0,
      }],
      areaIndex: '',
      scrollTop: '',
      roomIndex: '',
      cardIndex: '',
    }
  },
  watch: {
    formList: {
      handler(newVal, oldVal) {
        if (!this.offFirstEnter) {
          return;
        }
        console.log(newVal)
        if (!newVal.orderNo || newVal.orderNo == '') {
          newVal.orderNo = 0
        }
        if (!newVal.bussinessChannel || newVal.bussinessChannel == '') {
          newVal.bussinessChannel = 0
        }
        if (!newVal.platName || newVal.platName == '') {
          newVal.platName = 0
        }
        if (!newVal.verificatioCode || newVal.verificatioCode == '') {
          newVal.verificatioCode = 0
        }
        if (!newVal.allPrice || newVal.allPrice == '') {
          newVal.allPrice = 0
        }
        if (!newVal.businessReduce || newVal.businessReduce == '') {
          newVal.businessReduce = 0
        }
        if (!newVal.platformReduce || newVal.platformReduce == '') {
          newVal.platformReduce = 0
        }
        if (!newVal.voucher || newVal.voucher == '') {
          newVal.voucher = 0
        }
        if (!newVal.orderPrice || newVal.orderPrice == '') {
          newVal.orderPrice = 0
        }
        if (!newVal.actualPrice || newVal.actualPrice == '') {
          newVal.actualPrice = 0
        }
        if (!newVal.advancePayment || newVal.advancePayment == '') {
          newVal.advancePayment = 0
        }
        if (!newVal.balancePayment || newVal.balancePayment == '') {
          newVal.balancePayment = 0
        }
        if (!newVal.discount || newVal.discount == '') {
          newVal.discount = 0
        }
        this.formData.orderList.push(newVal)
        this.$forceUpdate()
        this.$nextTick(() => {
          window.scrollTo({
            top: this.scrollTop + 500,
            behavior: "smooth",
          });
          this.$forceUpdate()
        });
        console.log(this.scrollTop)
      }
    },
  },
  created() {
    bus.$on('listenToB', this.getBData);
  },
  methods: {
    // 返回前一页
    returnIndex() {
      this.$emit('dialogVisibleEvent', false);
      this.formData = {
        cardNo: '',
        customerName: '',
        orderList: []
      }
      this.$router.go(0);
    },
    //   继续识别操作
    addProject(event, index) {
      console.log(index)
      var that = this
      var imageBase = "";
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      var size = event.target.files[0].size / 1024;
      console.log('图片大小' + size)
      if (size > 1000) {
        this.compress(event.target.files[0], function (imgBase64) {
          imageBase = imgBase64;
          imageBase = imgBase64.replace("data:image/png;base64,", "");
          console.log('压缩')
          that.uploadImgResult(imageBase, index)
        })
      } else {
        reader.onload = function (e) {
          imageBase = e.target.result.replace("data:image/png;base64,", "");
          console.log('无压缩')
          console.log(imageBase)
          that.uploadImgResult(imageBase, index)
        }
      }
      this.$forceUpdate()
    },
    uploadImgResult(imageBase, index) {
      var that = this
      var formData = new FormData();
      formData.append("access_token", that.access_token)
      formData.append("id_card_side", "front")
      formData.append("image", imageBase)
      console.log('继续识别的当条索引index')
      console.log(index)
      console.log(this.formData.orderList[index])
      console.log(this.formData.orderList[index].bussinessChannel)
      // https://aip.baidubce.com/rest/2.0/ocr/v1/accurate_basic
      axios.post(" https://aip.baidubce.com/rest/2.0/ocr/v1/accurate_basic", formData, {
        header: {
          "Content-Type": "application/x-www-form-urlencoded/",
          "content-type": "application/json"
        },
      }).then((data) => {
        console.log("解析成功");
        that.items = data.data.words_result
        console.log(that.items)
        this.wordStr = that.items.map((obj) => {
          return "'" + obj.words + "'"
        }).toString()
        console.log(this.wordStr)
        if (imageBase.search("base64,") != -1) {
          this.formData.orderList[index].imageBase.push(imageBase)
        } else {
          this.formData.orderList[index].imageBase.push("data:image/png;base64," + imageBase)
        }
        // 区分不同平台
        if (this.formData.orderList[index].bussinessChannel == '大众点评') {
          that.items.forEach(ele => {
            if (ele.words.search("订单编号") != -1) {
              this.formData.orderList[index].orderNo = ele.words.replace(/[^0-9]/ig, '')
            }
            if (ele.words.search("券号：") != -1) {
              this.formData.orderList[index].verificatioCode = ele.words.replace(/[^0-9]/ig, '')
            }
          });
          if (this.wordStr.search("商品总价") != -1) {
            this.formData.orderList[index].allPrice = this.wordStr.match(/商品总价(\S*)/)[1].split(',')[0].match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("您的恢复") != -1) {
            console.log(this.wordStr.split(/您的恢复(\S*)/)[0].split(',').slice(-1))
            this.formData.orderList[index].platName = this.wordStr.split(/您的恢复(\S*)/)[0].split(',').slice(-1)
              .toString().replace(
                /\'/g, "");
          }
          if (this.wordStr.search("商家立减") != -1) {
            this.formData.orderList[index].businessReduce = this.wordStr.match(/商家立减(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("平台立减") != -1) {
            this.formData.orderList[index].platformReduce = this.wordStr.match(/平台立减(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("平台抵用券") != -1) {
            this.formData.orderList[index].voucher = this.wordStr.match(/平台抵用券(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("优惠金额") != -1) {
            this.formData.orderList[index].discount = this.wordStr.match(/优惠金额(\S*)/)[1].split(',')[0].match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("订单总价") != -1) {
            this.formData.orderList[index].orderPrice = this.wordStr.match(/订单总价(\S*)/)[1].split(',')[0].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("实际付款") != -1) {
            this.formData.orderList[index].actualPrice = this.wordStr.match(/实际付款(\S*)/)[1].split(',')[0].split('：')[1].match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("预定金") != -1) {
            this.formData.orderList[index].advancePayment = this.wordStr.match(/预定金(\S*)/)[1].split(',')[0].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          } else if (this.wordStr.search("预付款") != -1) {
            this.formData.orderList[index].advancePayment = this.wordStr.match(/预付款(\S*)/)[1].split(',')[0].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("尾款") != -1) {
            this.formData.orderList[index].balancePayment = this.wordStr.match(/尾款(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("可使用") != -1) {
            if (parseInt(this.wordStr.match(/可使用(\S*)/)[0].split(',')[0].match(/\(([^)]*)\)/)[1].replace(
              /[^0-9]/ig, '')) > 1) {
              this.formData.orderList[index].cardName = '是'
              this.formData.orderList[index].isSecondary = 1
            } else {
              this.formData.orderList[index].cardName = '否'
              this.formData.orderList[index].isSecondary = 0
            }
          }
        } else if (this.formData.orderList[index].bussinessChannel == '天猫') {
          console.log('天猫字段')
        } else if (this.formData.orderList[index].bussinessChannel == '新氧') {
          if (this.wordStr.search("订单编号") != -1) {
            this.formData.orderList[index].orderNo = this.wordStr.match(/订单编号(\S*)/)[1].split(',')[1]
              .replace(/\'/g, "")
              .replace(
                /[^0-9]/ig, '');
          }
          if (this.wordStr.search("预约码") != -1) {
            this.formData.orderList[index].cppointmentCode = this.wordStr.match(/预约码(\S*)/)[1].split(',')[0]
              .replace(
                /[^0-9]/ig, '')
          }
          if (this.wordStr.search("订单总金额") != -1) {
            this.formData.orderList[index].businessReduce = this.wordStr.match(/订单总金额(\S*)/)[1].split(',')[1]
              .replace(
                /\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("实付预约金") != -1) {
            this.formData.orderList[index].platformReduce = this.wordStr.match(/实付预约金(\S*)/)[1].split(',')[1]
              .replace(
                /\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("剩余应付（尾款）到院再付") != -1) {
            this.formData.orderList[index].voucher = this.wordStr.match(/剩余应付（尾款）到院再付(\S*)/)[1].split(',')[1]
              .replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("本单实付金额") != -1) {
            this.formData.orderList[index].orderPrice = this.wordStr.match(/本单实付金额(\S*)/)[1].split(':')[1]
              .replace(
                /\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
        } else if (this.formData.orderList[index].bussinessChannel == '微商城') {
          console.log('微商城字段')
        } else if (this.formData.orderList[index].bussinessChannel == '更美') {
          console.log('更美字段')
        } else if (this.formData.orderList[index].bussinessChannel == '悦美') {
          console.log('悦美字段')
        }
        let userId = JSON.parse(localStorage.getItem('userInfo')).empId
        var data = {
          useId: userId,
          imageData: this.wordStr,
        }
        importScanImage(data)
          .then((res) => {
            console.log('提交识别信息');
            console.log(res.result);
          })
          .catch((err) => {
            console.log(err)
            this.$toast.clear();
          })
        this.$forceUpdate()
      }).catch((err) => {
        console.log(err)
        console.log("请求解析失败");
        this.$toast.fail(err);
      })

    },
    compress(fileObj, callback) {
      if (typeof (FileReader) === 'undefined') {
        console.log("当前浏览器内核不支持base64图片压缩")
        directTurnIntoBase64(fileObj, callback);
      } else {
        try {
          var reader = new FileReader();
          reader.onload = function (e) {
            var image = $('<img/>');
            image.on('load', function () {
              // image.load(function () {
              var squareW = 1000, //定义画布大小,也就是图片压缩之后的像素
                squareH = 1000,
                canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 0, //压缩图片大小
                imageHeight = 0,
                offsetX = 0,
                offsetY = 0,
                data = '';
              canvas.width = squareW;
              canvas.height = squareH;
              context.clearRect(0, 0, squareW, squareH);

              if (this.width > squareW) {
                imageWidth = Math.round(squareW);
                imageHeight = squareH;
                offsetX = Math.round((imageWidth - squareW) / 2);
              } else {
                imageHeight = Math.round(squareH);
                imageWidth = squareW;
                offsetY = Math.round((imageHeight - squareH) / 2)
              }
              console.log('offsetY')
              console.log(offsetY)
              context.drawImage(this, offsetX, offsetY, imageWidth, imageHeight);
              var data = canvas.toDataURL('image/jpeg')
              callback(data)
              console.log(data)
            });
            image.attr('src', e.target.result)
          };
          reader.readAsDataURL(fileObj);
        } catch (e) {
          console.log('压缩失败!')
          //调用不压缩方法
          directTurnIntoBase64(fileObj, callback)
        }
      }
    },
    getBData(val) {
      console.log(val)
      this.offFirstEnter = val
    },
    //   信息确认
    confirmed() {
      console.log(this.formData)
      this.formData.orderList.forEach(ele => {
        if (ele.allPrice == '') {
          ele.allPrice = 0
        }
        if (ele.orderPrice == '') {
          ele.orderPrice = 0
        }
      });
      bus.$emit('listenToA', this.formData);
      this.$emit('showText', true);
      this.offFirstEnter = false
    },
    //   添加订单
    addOrder() {
      // 记录跳转位置
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      console.log(this.scrollTop)
      this.$emit('dialogVisibleEvent', false);
    },
    onArea(item) {
      console.log(item)
      console.log(this.areaIndex)
      this.showArea = false;
      this.formData.orderList[this.areaIndex].areaCode = item.id
      this.formData.orderList[this.areaIndex].areaName = item.name
    },
    onRoom(item) {
      this.showRoom = false;
      this.formData.orderList[this.roomIndex].dsepartmentCode = item.id
      this.formData.orderList[this.roomIndex].dsepartmentName = item.name
    },
    onCard(item) {
      console.log(item)
      console.log(this.cardIndex)
      this.showCard = false;
      this.formData.orderList[this.cardIndex].isSecondary = item.id
      this.formData.orderList[this.cardIndex].cardName = item.name
    },
    handArea(index) {
      this.areaIndex = index
    },
    handRoom(index) {
      this.roomIndex = index
    },
    handCard(index) {
      this.cardIndex = index
    }

  }
}

</script>
<style scoped>
.textHeader {
  height: 4rem;
  background: #fff;
  line-height: 4rem;
  display: flex;
  justify-content: center;
}

.vanIconText {
  position: absolute;
  left: 1rem;
  top: 1.5rem;
}

.textFoot {
  height: 5.4rem;
  background: #ffffff;
  /* border: 1px solid red; */
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.28);
  border-radius: 2.5rem 2.5rem 0 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.recognitionResult {
  background: #f5f8f9;
  /* background: red; */
}

.continueButton {
  margin-right: 3%;
  margin-top: 0.5rem;
}

.buttonContinue {
  display: flex;
  justify-content: flex-end;
}

.recognitionResult >>> .van-cell-group {
  width: 94%;
  margin: 0 auto;
}

.content {
  padding-bottom: 10rem;
  box-sizing: border-box;
  border-radius: 7px;
}

.formList {
  margin-top: 0.5rem;
  border: 1px solid #7ac7f4;
}

.recognitionResult >>> .van-cell__value {
  color: #323233 !important;
  -webkit-text-fill-color: #323233 !important;
}

.recognitionResult >>> .van-field--disabled .van-field__label {
  color: #323233 !important;
}

.recognitionResult >>> .van-field__control:disabled {
  color: #323233 !important;
  -webkit-text-fill-color: #323233 !important;
}

.imgInputOne {
  opacity: 0;
  width: 3.625rem;
  height: 1.5rem;
  border: 1px solid blue;
  position: absolute;
  right: 3%;
  margin-top: 0.5rem;
}

.recognitionResult >>> .van-cell::after {
  height: 1px;
  border: 1px solid #e5eefc;
}

.arrowLine {
  display: flex;
  align-items: center;
}

.arrowLine >>> .van-icon-arrow::before {
  margin-right: 0.5rem;
}

.dangerButton {
  margin-right: 3%;
}

.recognitionResult >>> .van-field__label {
  width: 7.2em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/textUpload/recognitionResult.vue